export function showAbout() {
    const { windowPopupFeatures } = WebpackConfig.ent;
    const { contextPath } = GlobalEnt;
    const time = new Date();
    const idStr = "aboutPage" + time.getTime();
    window.open(contextPath + "/About.act", idStr, windowPopupFeatures.about);
}

/**
 * Performs the Audit action from the click menu.
 *
 * EX: On the Web Auth list page, you'll find a clickMenuRow.tag like this:
 *
 * 	<csp:clickMenuRow type="AUDIT" action="../AuditCtrl.act?ngaID=@ROWID"/>
 *
 * The action link will be passed into this function for use. Each action URL will specify
 * a different endpoint/parameter based on which Audit Report the page loads.
 * @param action
 */
export function showReport(actionURI) {
    const { windowPopupFeatures } = WebpackConfig.ent;
    const time = new Date();
    const idStr = "reportPage" + time.getTime();
    window.open(actionURI, idStr, windowPopupFeatures.report);
}

export function showLargeReport(actionURI) {
    const { windowPopupFeatures } = WebpackConfig.ent;
    const time = new Date();
    const idStr = "reportPage" + time.getTime();
    window.open(actionURI, idStr, windowPopupFeatures.largeReport);
}

export function showWindowWithToolbar(actionURI) {
    const { windowPopupFeatures } = WebpackConfig.ent;
    const time = new Date();
    const idStr = "reportPage" + time.getTime();
    window.open(actionURI, idStr, windowPopupFeatures.report);
}

export function showStatus(statusURL) {
    const { windowPopupFeatures } = WebpackConfig.ent;
    window.open(statusURL, "statusWindow", windowPopupFeatures.status);
}

export function showImage(imgUrl) {
    const { windowPopupFeatures } = WebpackConfig.ent;

    const time = new Date();
    const idStr = "printImage" + time.getTime();
    const page = window.open("_blank", idStr, windowPopupFeatures.imagePrint);

    page.addEventListener('pageshow', function() {
        const image = page.document.createElement('img');
        image.src = imgUrl;
        image.addEventListener('load', function() {
            window.print();
        });
        page.close();
    });
}

export const openLinkInNewWindow = (link, shouldCloseWindow) => {
    if (shouldCloseWindow && link.includes('?')) {
        link += `&shouldCloseWindow=true`;
    } else if (shouldCloseWindow) {
        link += `?shouldCloseWindow=true`;
    }

    window.open(link, 'popup',
        'menubar=no, status=no, width=1400, height=1000, top=100, left=700');
};